import React from "react";
import { useLocation } from "react-router-dom";
import useBook from "../../hooks/useBook";
import useToc from "../../hooks/useToc";
import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import ContentCanvas from "../../shared_comp/ContentCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "grommet";
import { Close } from "grommet-icons";

import NumeroUnit from "../../shared_comp/NumeroUnit";

const StatisticsBook = () => {

  const [receivedBook, setReceivedBook] = React.useState(false)
  const [bookInfo, setBookInfo] = React.useState<any>(null)

  const [receivedTocs, setReceivedTocs] = React.useState(false);
  const [bookTocs, setBookTocs] = React.useState<any>(null)

  let location = useLocation();
  let navigate = useNavigate();
  console.log("StatisticsBook", location)

  React.useEffect(() => {
    const doc_id = location.hash.split("#").pop();
    if (doc_id) {
      const receiveBook = async () => {
        const resBook = await useBook.getBookById(doc_id);
        if (resBook.result) {
          setBookInfo(resBook.book)
          setReceivedBook(true)
        }
      }
      const receiveTocs = async () => {
        const resTocs = await useToc.getTocsByBookId(doc_id)

        if (resTocs.result) {
          let tocs_filtered = resTocs.tocs.filter((v: any) => v.usernote !== "")
        //   sort toc_filtered by order
            tocs_filtered.sort((a: any, b: any) => {
                if (a.toc_order < b.toc_order) {
                    return 1;
                }
                if (a.toc_order > b.toc_order) {
                    return -1;
                }
                return 0;
            });            
          setBookTocs(tocs_filtered)
          console.log("StatisticsBook tocs", resTocs.tocs, bookTocs);
        } else {
          setBookTocs([])
        }
        setReceivedTocs(true);
      }
      receiveBook()
      receiveTocs()
    }
  }, [location])

  return (
    <ArchiveCanvas>
      <SectionTitle title="정부자료 / 통계연보" />
      <ContentCanvas>
        <Box alignSelf="end">
          <Button
            hoverIndicator
            onClick={() => navigate("/archive/statistics")}
            icon={<Close size="15px" />} />
        </Box>
        {receivedBook && receivedTocs && bookTocs &&
          <Box width="100%" direction="column" height="full"
            align="start" justify="start"
          >
            <NumeroUnit bookinfo={bookInfo} tocinfo={bookTocs} />
          </Box>
        }
      </ContentCanvas>
    </ArchiveCanvas>
  )
}

export default StatisticsBook;
